var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "my-5 mx-auto",
    attrs: {
      "max-width": "600",
      "loading": _vm.loading
    }
  }, [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "card-avatar, article, actions"
    }
  }) : _c('div', [_c('debug', {
    attrs: {
      "debug": _vm.selection
    }
  }), _c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "100px",
      "min-width": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": _vm.charging
    }
  }, [_c('v-card-title', {
    on: {
      "click": function click($event) {
        return _vm.goToChargingStation(_vm.selection);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.selection.name) + " ")]), _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.selection.chargingPointCount || "1") + " 🔌 • " + _vm._s(_vm.selection.connectionPowerInKwh) + " KW/h • " + _vm._s(_vm.selection.isRegistered ? "BNetz-A Registriert ♻️" : "Nicht Eingetragen ⚠️"))])], 1), _c('v-card-text', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-ev-plug-tesla")])], 1), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.selection.chargingPointCount) + " x " + _vm._s(_vm.selection.connectionPowerInKwh) + " KW/h ")])], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-calendar")])], 1), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.commissioningDate) + " ")])], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.selection.address.street) + ", " + _vm._s(_vm.selection.address.zip) + " " + _vm._s(_vm.selection.address.city) + ", " + _vm._s(_vm.selection.address.state) + " ")])], 1)], 1), _c('v-divider', {
    staticClass: "mx-4"
  }), _c('v-card-title', [_vm._v(_vm._s(_vm.$t("report.thgChargingStation.meterReading.title")))]), _c('v-card-text', _vm._l(_vm.meterReadings, function (meterReading) {
    return _c('v-list-item', {
      key: meterReading.id
    }, [_c('v-list-item-avatar', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
              attrs = _ref.attrs;
          return [_c('v-chip', {
            attrs: {
              "dark": "",
              "color": _vm.thgStatus(meterReading.status).color
            }
          }, [_c('v-icon', _vm._g(_vm._b({}, 'v-icon', attrs, false), on), [_vm._v(" " + _vm._s(_vm.thgStatus(meterReading.status).icon) + " ")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t(_vm.thgStatus(meterReading.status).text)))])])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(meterReading.meterReading.amountInKwh) + " KW/h ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.toDate(meterReading.meterReading.startDate)) + " - " + _vm._s(_vm.toDate(meterReading.meterReading.startDate)) + " ")])], 1)], 1);
  }), 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "d-none d-sm-block ml-2",
    attrs: {
      "dense": "",
      "small": "",
      "flat": "",
      "depressed": "",
      "color": _vm.partnerColor.primary,
      "dark": ""
    },
    on: {
      "click": _vm.addMeterReading
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("report.thgMeterReadingCreate.create")) + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }